// Debriefs fit quiz (size, then style)
(function() {
  const styles = `
    .button--quiz {
      position: relative;
      opacity: 1;
      transform: translateY(0);
    }

    .quiz-modal,
    .quiz-modal * {
      box-sizing: border-box;
    }

    .quiz-modal {
      position: fixed;
      right: 2rem;
      bottom: 2rem;
      z-index: 99999;
      display: flex;
      width: 390px;
      max-height: calc(100vh - 32px);
      max-height: calc(100dvh - 32px);
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      border-radius: 0;
      box-shadow: 0 6px 22px rgba(37, 37, 37, 0.12);
      color: #252525;
      opacity: 0;
      transform: translateY(40px);
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
    }

    .quiz-modal.is-active {
      opacity: 1;
      transform: translateY(0);
    }

    .quiz-header {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: space-between;
      padding: 12px 20px 10px;
      background: #fff;
    }

    .quiz-header h3 {
      margin: 0;
      color: #252525;
      font-family: 'Playfair Display', serif;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: -0.3px;
      line-height: 26px;
    }

    .quiz-close {
      display: inline-flex;
      width: 44px;
      height: 44px;
      flex: 0 0 44px;
      align-items: center;
      justify-content: center;
      margin: -10px -12px -10px 0;
      padding: 0;
      border: 0;
      background: transparent;
      color: #252525;
      cursor: pointer;
      transition: opacity 0.2s ease;
    }

    .quiz-close:hover {
      opacity: 0.7;
    }

    .quiz-close svg {
      width: 20px;
      height: 20px;
    }

    .quiz-body {
      min-height: 0;
      flex: 1 1 auto;
      overflow-y: auto;
      padding: 6px 20px 20px;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    .quiz-step {
      display: flex;
      flex-direction: column;
      gap: 12px;
      opacity: 1;
      transform: translateY(0);
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    .quiz-step.is-leaving {
      opacity: 0;
      transform: translateY(-8px);
    }

    .quiz-section-head {
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin: 0;
      padding: 0;
    }

    .quiz-question {
      display: block;
      margin: 0;
      color: #252525;
      font-family: 'Playfair Display', serif;
      font-size: 17px;
      font-weight: 500;
      letter-spacing: -0.2px;
      line-height: 22px;
    }

    .quiz-question-help {
      display: block;
      margin: 0;
      color: #666;
      font-family: 'Open Sans', sans-serif;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }

    .quiz-size-input {
      display: flex;
      width: 100%;
      height: 50px;
      align-items: stretch;
      border: 1px solid #cacaca;
      background: #fff;
    }

    .quiz-size-btn {
      display: flex;
      width: 56px;
      flex: 0 0 56px;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: #252525;
      color: #fff;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-size: 24px;
      font-weight: 600;
      line-height: 1;
      transition: background-color 0.2s ease;
    }

    .quiz-size-btn:hover {
      background: #3b3b3b;
    }

    .quiz-size-value {
      display: flex;
      min-width: 0;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      gap: 5px;
      margin: 0;
    }

    .quiz-size-value:focus-within {
      box-shadow: inset 0 0 0 2px #252525;
    }

    .quiz-size-number {
      width: 40px;
      height: 44px;
      padding: 0;
      border: 0;
      outline: 0;
      background: transparent;
      color: #252525;
      -moz-appearance: textfield;
      font-family: 'Open Sans', sans-serif;
      font-size: 18px;
      font-weight: 600;
      line-height: 44px;
      text-align: right;
    }

    .quiz-size-number::-webkit-outer-spin-button,
    .quiz-size-number::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }

    .quiz-size-unit {
      color: #252525;
      font-family: 'Open Sans', sans-serif;
      font-size: 18px;
      font-weight: 600;
    }

    .quiz-size-summary {
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 12px;
    }

    .quiz-size-code {
      position: relative;
      flex: 0 0 auto;
      color: #252525;
      font-family: 'Playfair Display', serif;
      font-size: 28px;
      font-weight: 500;
      line-height: 30px;
    }

    /* Same star that marks the recommended size on the product page. */
    .quiz-size-code::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -9px;
      width: 10px;
      height: 10px;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%232e8540' stroke='%23fff' stroke-width='1.5' stroke-linejoin='round' d='M12 1.8l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.9l-6.4 3.5L7 14.3l-5.3-5 7.2-.9z'/%3E%3C/svg%3E") center / contain no-repeat;
    }

    .quiz-size-details {
      display: flex;
      min-width: 0;
      flex-direction: column;
      gap: 1px;
      color: #666;
      font-family: 'Open Sans', sans-serif;
    }

    .quiz-size-label {
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.8px;
      line-height: 13px;
      text-transform: uppercase;
    }

    .quiz-size-range {
      color: #252525;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
    }

    .quiz-size-block {
      display: flex;
      min-height: 54px;
      align-items: center;
      justify-content: space-between;
      padding: 6px 16px;
      background: #f3f3f3;
    }

    .quiz-size-block--bar {
      flex: 0 0 auto;
      padding: 6px 20px;
    }

    .quiz-size-change {
      min-width: 56px;
      min-height: 44px;
      margin-right: -10px;
      padding: 0 10px;
      border: 0;
      background: transparent;
      color: #252525;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    .quiz-checks {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .quiz-check {
      position: relative;
      display: flex;
      min-height: 46px;
      align-items: center;
      gap: 12px;
      margin: 0;
      padding: 10px 14px;
      border: 1px solid #d8d8d8;
      background: #fff;
      color: #252525;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      transition: border-color 0.2s ease, background-color 0.2s ease, opacity 0.2s ease;
      -webkit-tap-highlight-color: transparent;
    }

    .quiz-check:hover {
      border-color: #252525;
    }

    .quiz-check input {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: 0;
      opacity: 0;
      pointer-events: none;
    }

    .quiz-check-box {
      display: inline-flex;
      width: 20px;
      height: 20px;
      flex: 0 0 20px;
      align-items: center;
      justify-content: center;
      border: 1.5px solid #8a8a8a;
      background: #fff;
      color: #fff;
      transition: background-color 0.15s ease, border-color 0.15s ease;
    }

    .quiz-check-box svg {
      width: 13px;
      height: 13px;
      opacity: 0;
    }

    .quiz-check.is-checked {
      border-color: #252525;
      background: #f7f7f7;
    }

    .quiz-check.is-checked .quiz-check-box {
      border-color: #252525;
      background: #252525;
    }

    .quiz-check.is-checked .quiz-check-box svg {
      opacity: 1;
    }

    .quiz-check.is-disabled {
      cursor: default;
      opacity: 0.4;
    }

    .quiz-check.is-disabled:hover {
      border-color: #d8d8d8;
    }

    .quiz-check input:focus-visible + .quiz-check-box {
      outline: 2px solid #252525;
      outline-offset: 2px;
    }

    .quiz-result {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .quiz-modal[data-step='1'] .quiz-body {
      padding-top: 18px;
    }

    .quiz-modal[data-step='1'] legend.quiz-section-head {
      margin-bottom: 14px !important;
    }

    .quiz-size-head {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 12px;
    }

    .quiz-unit {
      display: inline-flex;
      flex: 0 0 auto;
      border: 1px solid #cacaca;
    }

    .quiz-modal .quiz-unit button {
      display: inline-flex;
      width: 44px;
      height: 34px;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      text-align: center;
      border: 0;
      border-radius: 0;
      background: #fff;
      color: #666;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-size: 13px;
      font-weight: 600;
      line-height: 1;
    }

    .quiz-modal .quiz-unit button[aria-pressed='true'] {
      background: #252525;
      color: #fff;
    }

    .quiz-result-label {
      color: #666;
      font-family: 'Open Sans', sans-serif;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.8px;
      line-height: 13px;
      text-transform: uppercase;
    }

    .quiz-result-product {
      margin: 0;
      color: #252525;
      font-family: 'Playfair Display', serif;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: -0.3px;
      line-height: 26px;
    }

    .quiz-result-reason,
    .quiz-result-empty {
      margin: 0;
      color: #606060;
      font-family: 'Open Sans', sans-serif;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }

    .quiz-primary-button {
      display: inline-flex;
      width: 100%;
      height: 50px;
      flex: 0 0 50px;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
      border: 0;
      border-radius: 0;
      background: #252525;
      color: #fff;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1.6px;
      line-height: 18px;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
      transition: opacity 0.2s ease;
    }

    .quiz-primary-button:hover {
      color: #fff;
      opacity: 0.88;
    }

    .quiz-primary-button.is-disabled {
      pointer-events: none;
      opacity: 0.3;
    }

    .size-recommendation {
      display: none !important;
    }

    .quiz-overlay {
      position: fixed;
      inset: 0;
      z-index: 99998;
      background: rgba(37, 37, 37, 0.5);
      opacity: 0;
      touch-action: none;
      transition: opacity 0.3s ease;
    }

    @media (max-width: 768px) {
      .quiz-modal {
        right: 0;
        bottom: 0;
        width: 100%;
        border-radius: 10px 10px 0 0;
        max-height: calc(100vh - 8px);
        max-height: calc(100dvh - 8px);
        transform: translateY(100%);
      }

      .quiz-modal.is-active {
        transform: translateY(0);
      }

      .quiz-body {
        padding-bottom: max(20px, env(safe-area-inset-bottom));
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .quiz-modal,
      .quiz-overlay,
      .quiz-step,
      .quiz-check,
      .quiz-check-box,
      .quiz-primary-button,
      .quiz-close,
      .quiz-size-btn {
        transition-duration: 0.01ms !important;
      }
    }
  `;

  if (!document.getElementById('db-fit-quiz-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'db-fit-quiz-styles';
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }

  const FIT_NEEDS = [
    { value: 'chafing', label: 'My thighs rub or I get chafing' },
    { value: 'active', label: 'I train or I’m on my feet all day' },
    { value: 'coverage', label: 'I like more leg coverage' },
    { value: 'none', label: 'None of these' }
  ];

  const PRODUCT_HANDLES = ['trunks', 'boxer-briefs'];

  class FitQuiz {
    constructor() {
      this.step = 0;
      this.answers = this.getDefaultAnswers();
      this.isOpen = false;
      this.hasCompleted = false;
      this.products = {};
      this.previouslyFocusedElement = null;
      this.handleKeydown = this.handleKeydown.bind(this);
      this.init();
    }

    getDefaultAnswers() {
      const saved = this.getSavedWaist();
      return {
        unit: saved.unit,
        waistValue: saved.value,
        chafing: false,
        active: false,
        coverage: false,
        none: false
      };
    }

    getStoredRecommendation() {
      try {
        return JSON.parse(localStorage.getItem('underwearFitRecommendation') || 'null');
      } catch (error) {
        return null;
      }
    }

    getSavedWaist() {
      const saved = this.getStoredRecommendation();
      let unit = 'in';
      try {
        unit = localStorage.getItem('dbFitQuizUnit') === 'cm' ? 'cm' : 'in';
      } catch (error) {
        // Default to inches.
      }

      if (saved && saved.unit === 'cm' && saved.waistCm) {
        return { unit: 'cm', value: this.normaliseWaist(saved.waistCm, 'cm') };
      }
      if (saved && saved.waistSize) {
        const inches = this.normaliseWaist(saved.waistSize, 'in');
        return unit === 'cm'
          ? { unit, value: this.normaliseWaist(Math.round(inches * 2.54), 'cm') }
          : { unit, value: inches };
      }
      return unit === 'cm' ? { unit, value: 81 } : { unit, value: 32 };
    }

    resetQuiz() {
      this.step = 0;
      this.answers = this.getDefaultAnswers();
      this.hasCompleted = false;
      this.sizeChanged = false;
    }

    init() {
      this.insertQuizButton();

      document.addEventListener('product:updated', () => {
        setTimeout(() => this.applySizeRecommendation(), 500);
      });
    }

    insertQuizButton() {
      const primaryButton = document.querySelector('.slideshow__slide .button--primary');
      if (!primaryButton || document.querySelector('.button--quiz')) {
        return;
      }

      const buttonWrapper = primaryButton.closest('.button-wrapper, .button-group__wrapper');
      if (!buttonWrapper) {
        return;
      }

      const quizButton = document.createElement('button');
      quizButton.type = 'button';
      quizButton.className = 'button button--secondary button--quiz';
      quizButton.textContent = 'Find your fit';
      quizButton.addEventListener('click', () => this.openQuiz());

      if (buttonWrapper.classList.contains('button-wrapper')) {
        const newButtonGroup = document.createElement('div');
        newButtonGroup.className = 'button-group';
        newButtonGroup.innerHTML = '<div class="button-group__wrapper"></div>';
        buttonWrapper.parentNode.replaceChild(newButtonGroup, buttonWrapper);
        const groupWrapper = newButtonGroup.querySelector('.button-group__wrapper');
        groupWrapper.appendChild(primaryButton);
        groupWrapper.appendChild(quizButton);
        return;
      }

      buttonWrapper.appendChild(quizButton);
    }

    getRoot() {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return root || '/';
    }

    loadProducts() {
      PRODUCT_HANDLES.forEach(handle => {
        if (this.products[handle]) {
          return;
        }

        this.products[handle] = fetch(`${this.getRoot()}products/${handle}.js`)
          .then(response => (response.ok ? response.json() : null))
          .catch(() => null);
      });
    }

    getProductUrl(handle) {
      return `${this.getRoot()}products/${handle}`;
    }

    // First colour that has the recommended size in stock, else the first colour with that size.
    findVariantId(product, sizeCode) {
      if (!product || !Array.isArray(product.variants)) {
        return null;
      }

      const sizeIndex = (product.options || []).findIndex(option => {
        const name = typeof option === 'string' ? option : option.name;
        return /size/i.test(name || '');
      });
      const matchesSize = variant => {
        const values = sizeIndex >= 0 ? [variant.options[sizeIndex]] : variant.options;
        return values.includes(sizeCode);
      };

      const available = product.variants.find(variant => variant.available && matchesSize(variant));
      const anyMatch = product.variants.find(matchesSize);
      const variant = available || anyMatch;
      return variant ? variant.id : null;
    }

    updateShopLink() {
      const link = document.querySelector('.quiz-modal .quiz-submit');
      const recommendation = this.calculateRecommendation();
      if (!link || !recommendation) {
        return;
      }

      const baseUrl = this.getProductUrl(recommendation.productType);
      link.setAttribute('href', baseUrl);

      Promise.resolve(this.products[recommendation.productType]).then(product => {
        const current = this.calculateRecommendation();
        if (!current || current.productType !== recommendation.productType || current.sizeCode !== recommendation.sizeCode) {
          return;
        }

        const variantId = this.findVariantId(product, recommendation.sizeCode);
        if (variantId && link.isConnected) {
          link.setAttribute('href', `${baseUrl}?variant=${variantId}`);
        }
      });
    }

    getWaistLimits(unit) {
      return unit === 'cm' ? { min: 70, max: 120, fallback: 81 } : { min: 28, max: 47, fallback: 32 };
    }

    normaliseWaist(value, unit = this.answers.unit) {
      const limits = this.getWaistLimits(unit);
      return Math.min(limits.max, Math.max(limits.min, parseInt(value, 10) || limits.fallback));
    }

    getWaistCm() {
      return this.answers.unit === 'cm' ? this.answers.waistValue : this.answers.waistValue * 2.54;
    }

    getWaistInches() {
      return this.answers.unit === 'cm' ? Math.round(this.answers.waistValue / 2.54) : this.answers.waistValue;
    }

    // Ranges follow the theme's Sizing Chart in each unit.
    getSizeDetails() {
      const unit = this.answers.unit;
      const value = this.answers.waistValue;
      const sizes = [
        { maxIn: 30, maxCm: 78, size: 'Small', sizeCode: 'S', in: '28–30 in', cm: '70–78 cm' },
        { maxIn: 34, maxCm: 88, size: 'Medium', sizeCode: 'M', in: '31–34 in', cm: '79–88 cm' },
        { maxIn: 38, maxCm: 98, size: 'Large', sizeCode: 'L', in: '35–38 in', cm: '89–98 cm' },
        { maxIn: 43, maxCm: 108, size: 'Extra Large', sizeCode: 'XL', in: '39–43 in', cm: '99–108 cm' },
        { maxIn: Infinity, maxCm: Infinity, size: 'Double Extra Large', sizeCode: 'XXL', in: '44–47 in', cm: '109–118 cm' }
      ];
      const match = sizes.find(size => value <= (unit === 'cm' ? size.maxCm : size.maxIn));
      const measurement = `${match.in.replace(' in', '"')} (${match.cm})`.replace(/–/g, '-');

      return { size: match.size, sizeCode: match.sizeCode, range: match[unit], measurement };
    }

    hasStyleAnswer() {
      const { chafing, active, coverage, none } = this.answers;
      return chafing || active || coverage || none;
    }

    calculateRecommendation() {
      if (!this.hasStyleAnswer()) {
        return null;
      }

      const size = this.getSizeDetails();
      const { chafing, active, coverage } = this.answers;
      const productType = chafing || active || coverage ? 'boxer-briefs' : 'trunks';
      const needs = [
        chafing && 'thighs that rub',
        active && 'active days',
        coverage && 'more leg coverage'
      ].filter(Boolean);
      const needList = needs.length > 1
        ? `${needs.slice(0, -1).join(', ')} and ${needs[needs.length - 1]}`
        : needs[0];
      const reason = productType === 'boxer-briefs'
        ? `The longer leg, suited to ${needList}.`
        : 'The shorter leg, suited to everyday wear.';

      const productName = productType === 'boxer-briefs' ? 'Boxer Briefs' : 'Trunks';

      return {
        productType,
        productName,
        // `size` holds the variant option value (S, M, L…) read by the PDP size recommendation.
        size: size.sizeCode,
        sizeCode: size.sizeCode,
        sizeName: size.size,
        range: size.range,
        measurement: size.measurement,
        waistSize: this.getWaistInches(),
        waistCm: Math.round(this.getWaistCm()),
        unit: this.answers.unit,
        reason,
        ctaText: `Shop ${productName.toLowerCase()} in ${size.sizeCode}`
      };
    }

    saveRecommendation(recommendation) {
      try {
        localStorage.setItem('underwearFitRecommendation', JSON.stringify(recommendation));
      } catch (error) {
        // Storage can be unavailable in private browsing.
      }
    }

    // Saves the latest size as soon as it changes, so closing the quiz keeps it.
    saveSize() {
      const size = this.getSizeDetails();
      this.saveRecommendation(Object.assign({}, this.getStoredRecommendation(), {
        size: size.sizeCode,
        sizeCode: size.sizeCode,
        sizeName: size.size,
        range: size.range,
        measurement: size.measurement,
        waistSize: this.getWaistInches(),
        waistCm: Math.round(this.getWaistCm()),
        unit: this.answers.unit
      }));
      this.sizeChanged = true;
    }

    getSizeSummaryMarkup() {
      const size = this.getSizeDetails();

      return `
        <div class="quiz-size-summary">
          <span class="quiz-size-code">${size.sizeCode}</span>
          <span class="quiz-size-details">
            <span class="quiz-size-label">Your size</span>
            <span class="quiz-size-range">${size.size} · ${size.range}</span>
          </span>
        </div>
      `;
    }

    createQuizModal() {
      const modal = document.createElement('div');

      modal.className = 'quiz-modal';
      modal.dataset.step = String(this.step);
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'fit-quiz-title');

      modal.innerHTML = `
        <div class="quiz-header">
          <h3 id="fit-quiz-title">Find your fit</h3>
          <button type="button" class="quiz-close" aria-label="Close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        ${this.step === 1 ? `
          <div class="quiz-size-block quiz-size-block--bar" aria-live="polite">
            ${this.getSizeSummaryMarkup()}
            <button type="button" class="quiz-size-change">Change</button>
          </div>
        ` : ''}
        <div class="quiz-body">
          ${this.step === 0 ? this.getSizeStepMarkup() : this.getStyleStepMarkup()}
        </div>
      `;

      modal.querySelector('.quiz-close').addEventListener('click', () => this.closeQuiz());
      if (this.step === 0) {
        this.attachSizeListeners(modal);
      } else {
        this.attachStyleListeners(modal);
      }
      return modal;
    }

    getSizeStepMarkup() {
      return `
        <div class="quiz-step">
          <div class="quiz-size-head">
            <div class="quiz-section-head">
              <p class="quiz-question">Your waist size</p>
              <p class="quiz-question-help">Your usual pants size.</p>
            </div>
            <div class="quiz-unit" role="group" aria-label="Measurement unit">
              <button type="button" data-unit="in" aria-pressed="${this.answers.unit === 'in'}">in</button>
              <button type="button" data-unit="cm" aria-pressed="${this.answers.unit === 'cm'}">cm</button>
            </div>
          </div>
          <div class="quiz-size-input">
            <button class="quiz-size-btn minus" type="button" aria-label="Decrease waist size">−</button>
            <label class="quiz-size-value">
              <input type="number" min="${this.getWaistLimits(this.answers.unit).min}" max="${this.getWaistLimits(this.answers.unit).max}" value="${this.answers.waistValue}" class="quiz-size-number" inputmode="numeric" aria-label="Waist size in ${this.answers.unit === 'cm' ? 'centimetres' : 'inches'}">
              <span class="quiz-size-unit" aria-hidden="true">${this.answers.unit}</span>
            </label>
            <button class="quiz-size-btn plus" type="button" aria-label="Increase waist size">+</button>
          </div>
          <div class="quiz-size-block" aria-live="polite">
            ${this.getSizeSummaryMarkup()}
          </div>
          <button type="button" class="quiz-primary-button quiz-continue">Find your style</button>
        </div>
      `;
    }

    getStyleStepMarkup() {
      const checkIcon = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><polyline points="3 8.5 6.5 12 13 4.5"></polyline></svg>';

      return `
        <div class="quiz-step">
          <fieldset style="margin: 0; padding: 0; border: 0; min-width: 0;">
            <legend class="quiz-section-head" style="margin-bottom: 14px;">
              <span class="quiz-question">Any of these sound like you?</span>
              <span class="quiz-question-help">Tick all that apply, or none of these.</span>
            </legend>
            <div class="quiz-checks">
              ${FIT_NEEDS.map(need => `
                <label class="quiz-check" data-value="${need.value}">
                  <input type="checkbox" value="${need.value}">
                  <span class="quiz-check-box" aria-hidden="true">${checkIcon}</span>
                  <span>${need.label}</span>
                </label>
              `).join('')}
            </div>
          </fieldset>
          <div class="quiz-result" aria-live="polite">
            ${this.getResultMarkup()}
          </div>
          <a href="${this.getProductUrl('trunks')}" class="quiz-primary-button quiz-submit is-disabled" aria-disabled="true" tabindex="-1">Shop now</a>
        </div>
      `;
    }

    getResultMarkup() {
      const recommendation = this.calculateRecommendation();

      if (!recommendation) {
        return '<p class="quiz-result-empty">Pick at least one option to find your style.</p>';
      }

      return `
        <span class="quiz-result-label">We’d suggest</span>
        <p class="quiz-result-product">${recommendation.productName}, size ${recommendation.sizeCode}</p>
        <p class="quiz-result-reason">${recommendation.reason}</p>
      `;
    }

    attachSizeListeners(modal) {
      const input = modal.querySelector('.quiz-size-number');
      const sizeBlock = modal.querySelector('.quiz-body .quiz-size-block');
      const continueButton = modal.querySelector('.quiz-continue');

      const updateSize = value => {
        const normalisedValue = this.normaliseWaist(value);
        this.answers.waistValue = normalisedValue;
        input.value = normalisedValue;
        sizeBlock.innerHTML = this.getSizeSummaryMarkup();
        this.saveSize();
      };

      modal.querySelectorAll('.quiz-unit button').forEach(button => {
        button.addEventListener('click', () => {
          const unit = button.dataset.unit;
          if (unit === this.answers.unit) {
            return;
          }

          const converted = unit === 'cm'
            ? Math.round(this.answers.waistValue * 2.54)
            : Math.round(this.answers.waistValue / 2.54);
          this.answers.unit = unit;
          this.answers.waistValue = this.normaliseWaist(converted, unit);
          try {
            localStorage.setItem('dbFitQuizUnit', unit);
          } catch (error) {
            // Storage can be unavailable in private browsing.
          }
          this.updateQuiz();
        });
      });

      modal.querySelector('.quiz-size-btn.minus').addEventListener('click', () => updateSize(this.answers.waistValue - 1));
      modal.querySelector('.quiz-size-btn.plus').addEventListener('click', () => updateSize(this.answers.waistValue + 1));
      input.addEventListener('change', event => updateSize(event.currentTarget.value));
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          updateSize(event.currentTarget.value);
          continueButton.click();
        }
      });

      continueButton.addEventListener('click', () => {
        updateSize(input.value);
        const size = this.getSizeDetails();
        this.trackEvent('quiz_waist_size', `${size.sizeCode}:${this.getWaistInches()}`);
        this.goToStep(1);
      });
    }

    attachStyleListeners(modal) {
      const result = modal.querySelector('.quiz-result');
      const shopButton = modal.querySelector('.quiz-submit');
      const labels = modal.querySelectorAll('.quiz-check');

      modal.querySelector('.quiz-size-change').addEventListener('click', () => this.goToStep(0));

      const render = () => {
        labels.forEach(label => {
          const value = label.dataset.value;
          const input = label.querySelector('input');
          const isDisabled = value !== 'none' && this.answers.none;
          input.checked = this.answers[value];
          input.disabled = isDisabled;
          label.classList.toggle('is-checked', this.answers[value]);
          label.classList.toggle('is-disabled', isDisabled);
        });

        result.innerHTML = this.getResultMarkup();

        const recommendation = this.calculateRecommendation();
        shopButton.classList.toggle('is-disabled', !recommendation);
        if (recommendation) {
          shopButton.removeAttribute('aria-disabled');
          shopButton.removeAttribute('tabindex');
          shopButton.textContent = recommendation.ctaText;
          this.updateShopLink();
        } else {
          shopButton.setAttribute('aria-disabled', 'true');
          shopButton.setAttribute('tabindex', '-1');
          shopButton.textContent = 'Shop now';
        }
      };

      labels.forEach(label => {
        label.querySelector('input').addEventListener('change', event => {
          const value = event.currentTarget.value;
          this.answers[value] = event.currentTarget.checked;

          if (value === 'none' && this.answers.none) {
            this.answers.chafing = false;
            this.answers.active = false;
            this.answers.coverage = false;
          }

          render();
        });
      });

      shopButton.addEventListener('click', event => {
        if (!this.calculateRecommendation()) {
          event.preventDefault();
          return;
        }
        this.complete();
        this.trackEvent('quiz_shop_now', this.calculateRecommendation().productType);
      });

      render();
    }

    goToStep(nextStep) {
      const currentStep = document.querySelector('.quiz-modal .quiz-step');
      const swap = () => {
        this.step = nextStep;
        this.updateQuiz();
      };

      if (!currentStep) {
        swap();
        return;
      }

      currentStep.classList.add('is-leaving');
      setTimeout(swap, 180);
    }

    complete() {
      const recommendation = this.calculateRecommendation();
      if (this.hasCompleted || !recommendation) {
        return;
      }

      this.saveRecommendation(Object.assign({}, this.getStoredRecommendation(), recommendation));
      try {
        sessionStorage.setItem('justCompletedQuiz', 'true');
      } catch (error) {
        // Storage can be unavailable in private browsing.
      }

      this.hasCompleted = true;
      this.trackEvent('quiz_activity', this.answers.active ? 'active' : 'not_selected');
      this.trackEvent('quiz_chafing', this.answers.chafing ? 'yes' : 'no');
      this.trackEvent('quiz_coverage', this.answers.coverage ? 'yes' : 'no');
      this.trackEvent('quiz_complete', `${recommendation.productType}:${recommendation.sizeName}`);
    }

    updateQuiz() {
      const oldModal = document.querySelector('.quiz-modal');
      if (!oldModal) {
        return;
      }

      const newModal = this.createQuizModal();
      if (oldModal.classList.contains('is-active')) {
        newModal.classList.add('is-active');
      }
      oldModal.parentNode.replaceChild(newModal, oldModal);
    }

    lockPage(isLocked) {
      document.documentElement.classList.toggle('lock-all', isLocked);
    }

    openQuiz() {
      if (document.querySelector('.quiz-modal')) {
        return;
      }

      this.resetQuiz();
      this.loadProducts();
      this.previouslyFocusedElement = document.activeElement;

      const overlay = document.createElement('div');
      overlay.className = 'quiz-overlay';
      overlay.addEventListener('click', event => {
        if (event.target === overlay) {
          this.closeQuiz();
        }
      });
      document.body.appendChild(overlay);

      const modal = this.createQuizModal();
      document.body.appendChild(modal);
      this.lockPage(true);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
          modal.classList.add('is-active');
          const closeButton = modal.querySelector('.quiz-close');
          if (closeButton) {
            closeButton.focus({ preventScroll: true });
          }
        });
      });

      this.isOpen = true;
      document.addEventListener('keydown', this.handleKeydown);
      this.trackEvent('quiz_open', 'Quiz opened');
    }

    closeQuiz() {
      const modal = document.querySelector('.quiz-modal');
      const overlay = document.querySelector('.quiz-overlay');

      if (this.calculateRecommendation()) {
        this.complete();
      } else if (!this.hasCompleted) {
        this.trackEvent('quiz_abandoned', `Step ${this.step + 1}`);
      }

      if (modal) {
        modal.classList.remove('is-active');
        if (overlay) {
          overlay.style.opacity = '0';
        }

        setTimeout(() => {
          if (modal.parentNode) {
            modal.remove();
          }
          if (overlay && overlay.parentNode) {
            overlay.remove();
          }
          if (this.previouslyFocusedElement && typeof this.previouslyFocusedElement.focus === 'function') {
            this.previouslyFocusedElement.focus({ preventScroll: true });
          }
        }, 400);
      }

      if (this.sizeChanged || this.hasCompleted) {
        this.markRecommendedSize();
      }

      this.lockPage(false);
      this.isOpen = false;
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.closeQuiz();
      }
    }

    // Marks the saved size on the PDP. Clears the previous mark first so a changed size moves it.
    markRecommendedSize() {
      const recommendation = this.getStoredRecommendation();
      if (!recommendation || !recommendation.size) {
        return false;
      }

      const size = recommendation.size;
      let recommendedFound = false;

      document.querySelectorAll('.block-swatch--recommended').forEach(swatch => swatch.classList.remove('block-swatch--recommended'));
      document.querySelectorAll('.block-swatch').forEach(swatch => {
        const input = swatch.querySelector('input[type="radio"]');
        if (input && input.value === size) {
          swatch.classList.add('block-swatch--recommended');
          recommendedFound = true;
        }
      });

      return recommendedFound;
    }

    applySizeRecommendation() {
      const recommendation = this.getStoredRecommendation();
      if (this.markRecommendedSize() && recommendation) {
        this.trackEvent('recommendation_shown', recommendation.size);
      }
    }

    trackEvent(action, label = null, value = null) {
      if (typeof dbTrack !== 'function') {
        return;
      }

      const eventData = { event_category: 'Size Quiz' };
      if (label) {
        eventData.event_label = label;
      }
      if (value) {
        eventData.value = value;
      }
      dbTrack(action, eventData);
    }
  }

  function shouldOpenQuizFromUrl() {
    const hashTarget = (window.location.hash || '').split(/[?&]/)[0];
    if (hashTarget === '#fit-quiz' || hashTarget === '#fit_quiz') {
      return true;
    }

    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has('fit_quiz')) {
        return true;
      }
    } catch (error) {
      // Use the direct URL check below if URLSearchParams is unavailable.
    }

    return /[?&]fit_quiz(?:[=&#?]|$)/.test(window.location.href);
  }

  function initQuiz() {
    window.fitQuiz = new FitQuiz();
    if (shouldOpenQuizFromUrl()) {
      setTimeout(() => window.fitQuiz.openQuiz(), 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();
